import { lt } from '@mews/framework';
import { PriceAdjustmentDiscriminator } from '../schemas';

export const adjustmentOptions = [
    { value: PriceAdjustmentDiscriminator.None, label: lt('ConfigureProductServicesNoAdjustment') },
    { value: PriceAdjustmentDiscriminator.Fixed, label: lt('GeneralFixedPrice') },
    { value: PriceAdjustmentDiscriminator.Percentage, label: lt('GeneralPercentage') },
] as const;
